// assets/page-wishlist.js
(function () {
  const page = document.querySelector("[data-wishlist-page]");
  if (!page) return;

  // ---- DOM anchors (page) ----
  const savedGrid = page.querySelector("[data-wishlist-grid]");
  const emptyState = page.querySelector("[data-wishlist-empty]");
  const errorState = page.querySelector("[data-wishlist-error]");
  const countTargets = page.querySelectorAll("[data-wishlist-count-display]");
  const badgeTargets = page.querySelectorAll("[data-wishlist-count-badge]");
  const toolbar = page.querySelector("[data-wishlist-toolbar]");

  // ---- Header bubble (global) ----
  const bubbles = document.querySelectorAll("[data-wishlist-count]"); // header-clean.liquid

  // ---- Storefront API ----
  const TOKEN = window.STOREFRONT_TOKEN;
  const API_VERSION = window.STOREFRONT_API_VERSION || "2025-10";
  const STORE_URL =
    window.STORE_URL || `${location.protocol}//${location.host}`;
  const API_URL = `${STORE_URL}/api/${API_VERSION}/graphql.json`;

  if (!TOKEN) console.error("[Wishlist] Missing window.STOREFRONT_TOKEN");

  let currentRequestToken = 0;

  // ---------- ui helpers ----------
  const padCount = (n) => (n > 99 ? "99+" : n < 10 ? `0${n}` : String(n));

  function updateCountDisplay(count) {
    // hero + subheading
    countTargets.forEach((n) => (n.textContent = String(count)));
    badgeTargets.forEach((n) => (n.textContent = padCount(count)));

    // header bubble: pakai :empty CSS -> isi "" untuk sembunyi
    bubbles.forEach((b) => (b.textContent = count > 0 ? padCount(count) : ""));
  }

  function setLoading(on) {
    savedGrid?.classList.toggle("is-loading", !!on);
  }

  function showEmpty() {
    if (emptyState) emptyState.hidden = false;
    if (savedGrid) savedGrid.innerHTML = "";
    if (toolbar) toolbar.hidden = true;
  }
  function hideEmpty() {
    if (emptyState) emptyState.hidden = true;
  }

  function showError(msg) {
    if (!errorState) return;
    errorState.hidden = false;
    errorState.textContent = msg;
  }
  function hideError() {
    if (!errorState) return;
    errorState.hidden = true;
    errorState.textContent = "";
  }

  // ---------- utils ----------
  function normalizeHandle(raw) {
    if (!raw) return "";
    let s = String(raw).trim();
    if (!s) return "";
    if (s.includes("/")) {
      try {
        const u = new URL(s, location.origin);
        const m = u.pathname.match(/\/products\/([^/]+)/);
        if (m && m[1]) s = decodeURIComponent(m[1]);
      } catch {
        const p = s.split("?")[0].split("/products/");
        if (p.length > 1) s = decodeURIComponent(p[1].split("/")[0]);
      }
    }
    return s.toLowerCase();
  }

  function extractNumericIdFromGID(gid) {
    if (!gid) return null;
    const m = String(gid).match(/\d+$/);
    return m ? Number(m[0]) : null;
  }

  // ---------- Storefront API ----------
  async function sfQuery(query, variables) {
    const res = await fetch(API_URL, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        "X-Shopify-Storefront-Access-Token": TOKEN,
      },
      body: JSON.stringify({ query, variables }),
    });
    if (!res.ok) {
      const text = await res.text();
      throw new Error(`[SFAPI ${res.status}] ${text}`);
    }
    const json = await res.json();
    if (json.errors) throw new Error(`[SFAPI] ${JSON.stringify(json.errors)}`);
    return json.data;
  }

  const PRODUCT_Q = `
    query ProductByHandle($handle: String!) {
      product(handle: $handle) {
        id
        title
        handle
        onlineStoreUrl
        featuredImage { url altText }
        priceRange { minVariantPrice { amount currencyCode } maxVariantPrice { amount currencyCode } }
        variants(first: 50) {
          edges {
            node {
              id
              title
              availableForSale
              price { amount currencyCode }
              image { url altText }
            }
          }
        }
      }
    }`;

  async function fetchProductsByHandles(handles) {
    const list = handles.slice(0, 50);
    const jobs = list.map((h) =>
      sfQuery(PRODUCT_Q, { handle: h })
        .then((d) => d.product)
        .catch(() => null)
    );
    const results = await Promise.allSettled(jobs);
    return results
      .map((r) => (r.status === "fulfilled" ? r.value : null))
      .filter(Boolean);
  }

  // ---------- money ----------
  function money({ amount, currencyCode }) {
    const n = Number(amount || 0);
    try {
      return new Intl.NumberFormat(undefined, {
        style: "currency",
        currency: currencyCode || "USD",
      }).format(n);
    } catch {
      return `${currencyCode || "USD"} ${n.toFixed(2)}`;
    }
  }

  // ---------- wishlist storage helpers ----------
  function removeFromWishlist(handle) {
    const h = normalizeHandle(handle);
    try {
      if (window.CharmetixWishlist?.remove) {
        window.CharmetixWishlist.remove(h);
      } else {
        let wl = JSON.parse(localStorage.getItem("wishlist") || "[]");
        wl = wl.filter((x) => normalizeHandle(x) !== h);
        localStorage.setItem("wishlist", JSON.stringify(wl));
      }
    } catch {}
  }

  function readLocalWishlistHandles() {
    try {
      const arr = JSON.parse(localStorage.getItem("wishlist")) || [];
      return Array.isArray(arr)
        ? arr.map((h) => normalizeHandle(h)).filter(Boolean)
        : [];
    } catch {
      return [];
    }
  }

  function getHandlesFromEntries(entries) {
    return Array.from(
      new Set(
        (entries || [])
          .map((e) => normalizeHandle(e?.handle || e?.key || e?.url))
          .filter(Boolean)
      )
    );
  }

  function getHandles() {
    if (
      window.CharmetixWishlist &&
      typeof window.CharmetixWishlist.getEntries === "function"
    ) {
      return getHandlesFromEntries(window.CharmetixWishlist.getEntries());
    }
    return readLocalWishlistHandles();
  }

  // ---------- row renderer (table style) ----------
  function buildRowHTML(p) {
    if (!p) return "";

    const vEdges = (p.variants && p.variants.edges) || [];
    const firstVar = vEdges[0]?.node || null;

    const img =
      p.featuredImage?.url ||
      firstVar?.image?.url ||
      "https://via.placeholder.com/120x120?text=No+Image";
    const price = firstVar?.price ||
      p.priceRange?.minVariantPrice || { amount: "0.00", currencyCode: "USD" };
    const available = !!firstVar?.availableForSale;

    const variantOptions = vEdges
      .map(({ node }) => {
        const vNum = extractNumericIdFromGID(node.id);
        return `<option value="${vNum}" data-available="${
          node.availableForSale
        }" data-price="${node.price?.amount || ""}" data-currency="${
          node.price?.currencyCode || price.currencyCode
        }">${node.title}</option>`;
      })
      .join("");

    return `
      <div class="wl-row" data-row data-handle="${p.handle}">
        <div class="wl-cell">
          <div class="wl-prod">
            <span class="wl-thumb"><img src="${img}" alt="${(
      p.featuredImage?.altText || p.title
    ).replace(/"/g, "&quot;")}" loading="lazy"></span>
            <div class="wl-meta">
              <div class="wl-title"><a href="/products/${p.handle}">${
      p.title
    }</a></div>
              ${
                vEdges.length > 1
                  ? `<div class="wl-variant"><select class="variant-selector" data-handle="${p.handle}">${variantOptions}</select></div>`
                  : ""
              }
            </div>
          </div>
        </div>
        <div class="wl-cell wl-price"><span data-price>${money(
          price
        )}</span></div>
        <div class="wl-cell wl-stock"><span data-stock>${
          available ? "In stock" : "Sold out"
        }</span></div>
        <div class="wl-cell wl-actions">
          <button class="button button--secondary js-wl-add" data-variant-id="${
            extractNumericIdFromGID(firstVar?.id) || ""
          }" data-handle="${p.handle}" ${
      available ? "" : "disabled aria-disabled='true'"
    }>Add to cart</button>
          <button class="button button--tertiary js-wl-remove" data-handle="${
            p.handle
          }" type="button">Remove</button>
        </div>
      </div>
    `;
  }

  // ---------- wiring ----------
  function wireVariantSelectors(scope) {
    scope.querySelectorAll(".variant-selector").forEach((sel) => {
      sel.addEventListener("change", () => {
        const opt = sel.options[sel.selectedIndex];
        const row = sel.closest("[data-row]");
        const addBtn = row?.querySelector(".js-wl-add");
        const priceEl = row?.querySelector("[data-price]");
        const stockEl = row?.querySelector("[data-stock]");

        const vId = Number(opt.value);
        const available = opt.getAttribute("data-available") === "true";
        const amount = opt.getAttribute("data-price") || "";
        const currency = opt.getAttribute("data-currency") || "USD";

        if (addBtn) {
          addBtn.dataset.variantId = vId || "";
          if (!available || !vId) {
            addBtn.setAttribute("disabled", "");
            addBtn.setAttribute("aria-disabled", "true");
          } else {
            addBtn.removeAttribute("disabled");
            addBtn.removeAttribute("aria-disabled");
          }
        }
        if (priceEl && amount)
          priceEl.textContent = money({ amount, currencyCode: currency });
        if (stockEl) stockEl.textContent = available ? "In stock" : "Sold out";
      });
    });
  }

  function wireRemoveButtons(scope) {
    scope.querySelectorAll(".js-wl-remove").forEach((btn) => {
      btn.addEventListener("click", (e) => {
        e.preventDefault();
        const h = btn.dataset.handle;
        removeFromWishlist(h);
        document.dispatchEvent(
          new CustomEvent("wishlist:updated", {
            detail: { entries: getHandles().map((x) => ({ handle: x })) },
          })
        );
      });
    });
  }

  function wireAddToCartButtons(scope) {
    scope.querySelectorAll(".js-wl-add").forEach((btn) => {
      btn.addEventListener("click", async (e) => {
        e.preventDefault();
        const vId = Number(btn.dataset.variantId || 0);
        const handle = btn.dataset.handle;
        if (!vId) return;

        btn.disabled = true;
        try {
          const res = await fetch("/cart/add.js", {
            method: "POST",
            headers: { "Content-Type": "application/json" },
            body: JSON.stringify({ id: vId, quantity: 1 }),
          });
          if (!res.ok) {
            const err = await res.json().catch(() => ({}));
            throw new Error(
              err.message || `Add to cart failed (${res.status})`
            );
          }
          // sukses → hapus dari wishlist & refresh view
          removeFromWishlist(handle);
          document.dispatchEvent(
            new CustomEvent("wishlist:updated", {
              detail: { entries: getHandles().map((x) => ({ handle: x })) },
            })
          );
          try {
            document.dispatchEvent(new CustomEvent("cart:refresh"));
          } catch {}
        } catch (err) {
          console.error("[Wishlist] add to cart error", err);
        } finally {
          btn.disabled = false;
        }
      });
    });
  }

  function collectAddableItems() {
    const rows = document.querySelectorAll("[data-wl-table] [data-row]");
    const items = [];
    rows.forEach((row) => {
      const addBtn = row.querySelector(".js-wl-add");
      const vId = Number(addBtn?.dataset.variantId || 0);
      if (vId && !addBtn.disabled)
        items.push({ id: vId, quantity: 1, handle: row.dataset.handle });
    });
    return items;
  }

  function wireBulkButtons() {
    const addAll = document.querySelector("[data-wl-add-all]");
    const buyNow = document.querySelector("[data-wl-buy-now]");

    if (addAll)
      addAll.onclick = async () => {
        const items = collectAddableItems();
        if (!items.length) return;
        await fetch("/cart/add.js", {
          method: "POST",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify({
            items: items.map(({ id }) => ({ id, quantity: 1 })),
          }),
        });
        items.forEach((it) => removeFromWishlist(it.handle));
        document.dispatchEvent(
          new CustomEvent("wishlist:updated", {
            detail: { entries: getHandles().map((x) => ({ handle: x })) },
          })
        );
        try {
          document.dispatchEvent(new CustomEvent("cart:refresh"));
        } catch {}
      };

    if (buyNow)
      buyNow.onclick = async () => {
        const items = collectAddableItems();
        if (!items.length) return;
        await fetch("/cart/clear.js", { method: "POST" }).catch(() => {});
        await fetch("/cart/add.js", {
          method: "POST",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify({
            items: items.map(({ id }) => ({ id, quantity: 1 })),
          }),
        });
        items.forEach((it) => removeFromWishlist(it.handle));
        location.href = "/checkout";
      };
  }

  // ---------- render flow ----------
  async function renderSavedFromHandles(handles) {
    hideError();
    updateCountDisplay(handles.length);
    if (!savedGrid) return;

    if (handles.length === 0) {
      setLoading(false);
      showEmpty();
      return;
    }

    hideEmpty();
    setLoading(true);
    const reqToken = ++currentRequestToken;

    try {
      const products = await fetchProductsByHandles(handles);
      if (reqToken !== currentRequestToken) return;

      if (!products.length) {
        savedGrid.innerHTML = "";
        showEmpty();
        setLoading(false);
        return;
      }

      const html = products.map(buildRowHTML).join("");
      savedGrid.innerHTML = `<div class="wl-table" data-wl-table>${html}</div>`;
      setLoading(false);

      // interactivity
      wireVariantSelectors(savedGrid);
      wireAddToCartButtons(savedGrid);
      wireRemoveButtons(savedGrid);
      wireBulkButtons();

      // toolbar visibility
      if (toolbar) toolbar.hidden = products.length === 0;

      // safety: make sure empty hidden when we have products
      if (products.length > 0) hideEmpty();
    } catch (err) {
      console.error("[Wishlist] render error", err);
      if (reqToken !== currentRequestToken) return;
      setLoading(false);
      showError(
        page.dataset.wishlistError ||
          "We had trouble loading your saved items. Please refresh and try again."
      );
    }
  }

  async function renderSavedFromEntries(entries) {
    const handles = getHandlesFromEntries(entries);
    return renderSavedFromHandles(handles);
  }

  function init() {
    renderSavedFromHandles(getHandles());
  }

  // re-render saat ada event dari sistem wishlist-mu
  document.addEventListener("wishlist:updated", (ev) => {
    if (ev && ev.detail && Array.isArray(ev.detail.entries)) {
      renderSavedFromEntries(ev.detail.entries);
    } else {
      renderSavedFromHandles(getHandles());
    }
  });

  // cross-tab sync (localStorage)
  window.addEventListener("storage", (e) => {
    if (e.key === "wishlist") renderSavedFromHandles(getHandles());
  });

  // DOM ready
  if (document.readyState === "loading")
    document.addEventListener("DOMContentLoaded", init);
  else init();

  // fallback CTA href
  const ctaLink = page.querySelector("[data-wishlist-empty-cta]");
  if (ctaLink && !ctaLink.getAttribute("href"))
    ctaLink.setAttribute("href", "/collections/all");
})();
